import React, { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import swal from "sweetalert";
import { toast } from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";
import { editarSuperInstituto } from "../../../../shared/fetchers/classics/institutos/editarSuperInstituto";
import { CloseRounded, CheckRounded } from "@material-ui/icons";

const EditarSuperInstituto = ({ superInstituto, clearEdit }) => {
  const queryClient = useQueryClient();

  const [formData, setFormData] = useState({
    nombre: { value:  "", error: false },
    lecturasDiarias: { value: 0, error: false },
  });

  useEffect(() => {
    if (superInstituto) {
      setFormData({
        nombre: { value: superInstituto.nombre, error: false },
        lecturasDiarias: {
          value: superInstituto.lecturasDiarias ?? 0,
          error: false,
        },
      });
    }
  }, [superInstituto]);

  const updateForm = (e) => {
    const { value, name } = e.target;
    setFormData({
      ...formData,
      [name]: { ...formData[name], value: value, error: false },
    });
  };

  const validate = () => {
    let isValid = true;
    const temp = { ...formData };

    if (!temp.nombre.value) {
      temp.nombre.error = true;
      isValid = false;
      toast.error("El campo nombre no puede estar vacío");
    }

    setFormData(temp);
    return isValid;
  };

  const SubmitForm = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const { info, status } = await editarSuperInstituto({
      id: superInstituto.idSuperInstituto,
      nombre: formData.nombre.value,
      lecturasDiarias: formData.lecturasDiarias.value,
    });

    if (!status)
      return swal({
        title: "Error",
        text: info,
        icon: "error",
      });

    queryClient.invalidateQueries({
      queryKey: ["superInstitutos"],
    });

    toast.success("Super instituto editado correctamente");
    clearEdit();
  };

  return (
    <Col xs={12} className="content-white-box px-4 py-4">
      <div className="d-flex align-items-center">
        <PersonIcon style={{ fontSize: "17px" }} />
        <div className="admin-main-title-dark-gray ml-2 mt-1">
          Editar un super instituto
        </div>
      </div>
      <div className="admin-muted-text-small mt-2">
        Por favor ingresar la siguiente info:
      </div>
      <form onSubmit={SubmitForm}>
        <label className="admin-label-text mt-3 d-block">
          Nombre Actual
        </label>
        <TextField
          name="nombreAnterior"
          disabled
          value={superInstituto.nombre}
          onChange={updateForm}
          variant="outlined"
          size="small"
          style={{
            width: "100%",
            fontFamily: "'Noto Sans JP', sans-serif",
          }}
        />
        <label className="admin-label-text mt-3 d-block">
          Nombre Super Instituto
        </label>
        <TextField
          name="nombre"
          value={formData.nombre.value}
          onChange={updateForm}
          error={formData.nombre.error}
          helperText={
            formData.nombre.error
              ? "Este campo no puede estar vacío"
              : null
          }
          variant="outlined"
          size="small"
          placeholder="Nombre del Super Instituto"
          style={{
            width: "100%",
            fontFamily: "'Noto Sans JP', sans-serif",
          }}
        />
        <label className="admin-label-text mt-3 d-block">
          Lecturas Diarias
        </label>
        <TextField
          name="lecturasDiarias"
          type="number"
          value={formData.lecturasDiarias.value}
          onChange={updateForm}
          error={formData.lecturasDiarias.error}
          variant="outlined"
          size="small"
          placeholder="Lecturas diarias para el Super Instituto"
          style={{
            width: "100%",
            fontFamily: "'Noto Sans JP', sans-serif",
          }}
        />
        <div className="d-flex justify-content-end mt-4">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<CheckRounded />}
            style={{ background: "#81c868" }}
          >
            Editar Super Instituto
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              clearEdit();
            }}
            className="ml-2"
            startIcon={<CloseRounded style={{ fontSize: "25px" }} />}
            style={{ background: "#f05050" }}
          >
            Cancelar
          </Button>
        </div>
      </form>
    </Col>
  );
};

export default EditarSuperInstituto; 